import { BrowserRouter, Routes, Route } from "react-router-dom";
import Footer from "./Components/Footer/Footer";
import Navbar from "./Components/Navbar/Navbar";
import AdminLogin from "./Pages/Login";
import Admin from "./Pages/Admin"
import ProtectedRoute from "./ProductedRoutes";
import ListProduct from "./Components/ListProduct/ListProduct";
import AdminUpdatePassword from "./Pages/AdminUpdatePassword";

export const backend_url =
  process.env.NODE_ENV === 'development'
    ? process.env.REACT_APP_BACKEND_URL
    : process.env.REACT_APP_BACKEND_URL_PROD;

console.log("NODE_ENV:", process.env.NODE_ENV);
console.log("Backend URL:", backend_url);

export const currency = process.env.REACT_APP_CURRENCY;

function App() {
  return (
    <BrowserRouter>
      <div>
        <Navbar />
        {/* <Admin /> */}
        <Routes>
          {/* Admin Login Route */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Route */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute> 
            }
          />

          <Route path="/admin/update-password/aavryaa-fabhub/LigSMdNqVJwGacKDxgST" element={
            <ProtectedRoute>
              <AdminUpdatePassword />
            </ProtectedRoute>
          } />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
